module.exports = __webpack_public_path__ + "img/mmlogo.317a32a3.svg";